import React from 'react';
import { Button } from '../../ui/button';
import { Loader2, Trash2 } from 'lucide-react';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  clientName: string;
  clientEmail?: string;
  isLoading: boolean;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  clientName,
  clientEmail,
  isLoading
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg shadow-xl max-w-md w-full border border-white/10">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-red-500/10 rounded-lg">
              <Trash2 className="h-6 w-6 text-red-400" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white">Confirmer la suppression</h3>
              <p className="text-sm text-gray-400">Cette action est irréversible</p>
            </div>
          </div>

          <div className="bg-white/5 rounded-lg p-4 mb-6">
            <p className="text-white mb-2">
              Êtes-vous sûr de vouloir supprimer le client :
            </p>
            <p className="text-lg font-semibold text-yellow-400">
              {clientName}
            </p>
            {clientEmail && (
              <p className="text-sm text-gray-400 mt-1">
                {clientEmail}
              </p>
            )}
          </div>

          <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 mb-6">
            <p className="text-sm text-red-300">
              ⚠️ Attention : Toutes les données associées à ce client seront supprimées (permissions, accès aux concours, etc.)
            </p>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={onClose}
              disabled={isLoading}
              variant="outline"
              className="flex-1 border-white/10 text-gray-300 hover:bg-white/5"
            >
              Annuler
            </Button>
            <Button
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1 bg-gradient-to-r from-red-500 to-red-600 text-white hover:opacity-90"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Suppression...
                </>
              ) : (
                <>
                  <Trash2 className="h-4 w-4 mr-2" />
                  Supprimer
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
